import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { LoaderService } from "../services/loader.service";
import { LoaderState } from "../Models/interfaces/LoaderState";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.loaderState
      .pipe(takeUntil(this.destroy$))
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      });
  }

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
